import React from 'react';

import FormInput from '../input/FormInput';
import { Grid, Typography } from '@mui/material';

function PricesTable({ name, classes, products, ...props }) {
    return classes.map((cl) => {
        return <ClassRow key={JSON.stringify(cl)} classRow={cl} products={products} name={name} />;
    });
}

const ClassRowSx = {
    display: 'flex',
    alignItems: 'center',
};

const HiddenSx = {
    display: 'none',
};

const RowItem = {
    margin: (theme) => theme.spacing(1),
};

function ClassRow({ name, classRow, products }) {
    return (
        <Grid container sx={{ ...ClassRowSx, ...(classRow.props.hidden ? HiddenSx : {}) }}>
            <Grid item xs={classRow.props.xs ?? true} sx={RowItem}>
                <Typography variant="body1" fontWeight="bold">
                    {classRow.props.label}
                </Typography>
            </Grid>
            {products.map(({ name: productName, props }) => {
                const productProps = {
                    name: `${name}.${classRow.name}.${productName}`,
                    // TODO: Move this to the config file
                    props: {
                        type: 'number',
                        currency: '$',
                        valueAsNumber: true,
                        variant: 'outlined',
                        ...classRow.props.rowProps,
                        ...props,
                    },
                };
                return (
                    <Grid item xs={productProps.props.xs ?? true} sx={RowItem} key={productProps.name}>
                        <FormInput {...productProps} />
                    </Grid>
                );
            })}
        </Grid>
    );
}

export default PricesTable;
